import { render, staticRenderFns } from "./VLinkVideo.vue?vue&type=template&id=762bad0b&scoped=true&"
import script from "./VLinkVideo.vue?vue&type=script&lang=js&"
export * from "./VLinkVideo.vue?vue&type=script&lang=js&"
import style0 from "./VLinkVideo.vue?vue&type=style&index=0&id=762bad0b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762bad0b",
  null
  
)

export default component.exports